import { Head, Link } from "@inertiajs/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ArrowLeft } from "lucide-react";
import { ThemeProvider } from "@/components/ui/theme-provider";
import { ToastProvider } from "@/components/ui/toast";
import { Toaster } from "@/components/ui/toaster";
import UserProvider from "@/context/UserProvider";
import { TeamManagement } from "@/components/team_management/TeamManagement";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

export default function TeamManagementPage() {
  return (
    <>
      <Head title="Team Management" />
      <QueryClientProvider client={queryClient}>
        <UserProvider>
          <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
            <ToastProvider>
              <Toaster />
              <div className="flex h-screen flex-col overflow-hidden bg-background">
                <div className="shrink-0 border-b px-4 py-3 sm:px-6">
                  <Link
                    href="/"
                    className="inline-flex items-center text-sm text-muted-foreground hover:text-foreground"
                  >
                    <ArrowLeft className="mr-2 h-4 w-4" aria-hidden />
                    Back to Ordinal
                  </Link>
                </div>
                <main id="main-content" className="flex min-h-0 flex-1 flex-col overflow-hidden">
                  <TeamManagement />
                </main>
              </div>
            </ToastProvider>
          </ThemeProvider>
        </UserProvider>
      </QueryClientProvider>
    </>
  );
}
